var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1 flex flex-col bg-[#F8FAFC]"},[_c('div',{staticClass:"flex-1 px-6 pb-8"},[_c('div',{staticClass:"w-full max-w-3xl mx-auto"},[_c('DiagnoseWizard',{on:{"complete":_vm.handleComplete}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }